<template>
  <div id="forgot-page">
    <el-col :offset="8" :span="8">
      <template v-if="state === 'forgot'">
        <div @keydown.enter="submitEmail">
          <el-row style="display: inline-flex; margin-top: 50px; width: 100%">
            <el-col :span="10">
              <div class="lbl-login">{{ $t('common.email') }}:</div>
            </el-col>
            <el-col :span="14">
              <input class="input-login" v-model="email" type="text"/>
            </el-col>
          </el-row>
          <el-row style="display: inline-flex; margin-top: 20px; width: 100%">
            <el-col :span="24">
              <el-button style="font-size: 20px; width: 60%" type="success" @click="submitEmail">{{ $t('common.submit') }}</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
      <template v-if="state === 'reset'">
        <div @keydown.enter="submitPassword">
          <el-row style="display: inline-flex; margin-top: 50px; width: 100%">
            <el-col :span="10">
              <div class="lbl-login">OTP:</div>
            </el-col>
            <el-col :span="14">
              <input class="input-login" v-model="otp" type="text"/>
            </el-col>
          </el-row>
          <el-row style="display: inline-flex; margin-top: 20px; width: 100%">
            <el-col :span="10">
              <div class="lbl-login">{{ $t('common.new_password') }}:</div>
            </el-col>
            <el-col :span="14">
              <input class="input-login" v-model="password" type="password"/>
            </el-col>
          </el-row>
          <el-row style="display: inline-flex; margin-top: 20px; width: 100%">
            <el-col :span="10">
              <div class="lbl-login">{{ $t('common.password_confirm') }}:</div>
            </el-col>
            <el-col :span="14">
              <input class="input-login" v-model="confirmPassword" type="password"/>
            </el-col>
          </el-row>
          <el-row style="display: inline-flex; margin-top: 20px; width: 100%">
            <el-col :span="24">
              <el-button style="font-size: 20px; width: 60%" type="success" @click="submitPassword">{{ $t('common.submit') }}</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
      <el-row style="display: inline-flex; margin-top: 20px; width: 100%">
        <el-col :span="24" style="text-align: center; line-height: 42px; font-size: 20px; ">
          <a style="text-decoration: none" href="" @click="goLogin">{{ $t('common.login') }}</a>
        </el-col>
      </el-row>
    </el-col>
  </div>
</template>

<script>
  import { validEmail } from '@/utils'

  export default {
    name: "Login",
    components: {

    },
    data: function () {
      return {
        email: '',
        otp: '',
        password: '',
        confirmPassword: '',
        state: 'forgot'
      }
    },
    methods: {
      submitEmail: function () {
        let email = this.email.trim()

        if (!email) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.email_is_required')
          })

          return
        }

        if (!validEmail(this.email)) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.email_is_invalid')
          })

          return
        }

        let successCallback = () => {
          this.state = 'reset'
        }

        let payload = {
          successCallback,
          email
        }
        this.$store.dispatch('login/forgotPassword', payload)
      },
      submitPassword: function () {
        let otp = this.otp.trim()

        if (!otp) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.otp_is_required')
          })

          return
        }

        if (!this.password) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.password_is_required')
          })

          return
        }

        if (this.password !== this.confirmPassword) {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.confirm_password_not_match')
          })

          return
        }

        let successCallback = () => {
          this.$store.commit('openNotification', {
            type: 'success',
            message: this.$t('common.change_password_success')
          })

          this.$router.push('/login')
        }

        let payload = {
          successCallback,
          otp: this.otp,
          password: this.password
        }

        this.$store.dispatch('login/resetPassword', payload)
      },
      goLogin (e) {
        e.preventDefault()
        this.$router.push('/login')
      }
    }
  }
</script>

<style lang="scss">

</style>